import { useContext } from 'react';
import ReactJson from 'react-json-view';
import { Box } from '@mui/system';
import useStyles from './styles';
import { Paper } from '@mui/material';

import { generateConfig } from '../../../../utilities/helpers';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';

const FvpConfigOverview = () => {
	const { rawConfig } = useContext(FvpConfigContext);
	const classes = useStyles();
	return (
		<Box className={classes.overview}>
			<Paper elevation={2} className={classes.paper}>
				<ReactJson
					enableClipboard={true}
					displayDataTypes={false}
					src={generateConfig(rawConfig)}
				/>
			</Paper>
		</Box>
	);
};

export default FvpConfigOverview;
